import GenericApi from "@/api/genericApi";
import { CryptoDataQueryKey } from "@/config/constants/QueryKeys";
import { ApiResponse } from "@/types/Api";
import { CryptoData, Currency } from "@/types/Currency";
import { isBitramp } from "@/utils/utils";
import { useQuery } from "@tanstack/react-query";
import React from "react";

interface CurrencyOptionProps {
  option: Currency;
  handleClickOption: (option: Currency) => void;
}

const CurrencyOption: React.FC<CurrencyOptionProps> = ({
  option,
  handleClickOption,
}) => {
  const url = `https://min-api.cryptocompare.com/data`;

  const { data: cryptoData, error } = useQuery<ApiResponse<CryptoData>>({
    queryFn: async () =>
      GenericApi.get<CryptoData>(
        `/pricemultifull?fsyms=${option.code}&tsyms=${option.code}`,
        url
      ),
    queryKey: [CryptoDataQueryKey, option.code],
  });

  if (error || cryptoData?.error) {
    return <div>{cryptoData?.error?.message ?? "Something went wrong"}</div>;
  }

  const getMediaLink = () => {
    if (option.code) {
      return cryptoData?.data?.RAW?.[option.code]?.[option.code]?.IMAGEURL;
    }

    return null;
  };

  const mediaLink = getMediaLink();

  const flagUrls: Record<string, string> = {
    EUR: "https://flagcdn.com/w320/eu.png",
    USD: "https://flagcdn.com/w320/us.png",
    RON: "https://flagcdn.com/w320/ro.png",
    GBP: "https://flagcdn.com/w320/gb.png",
    JPY: "https://flagcdn.com/w320/jp.png",
    PLN: "https://flagcdn.com/w320/pl.png",
    AUD: "https://flagcdn.com/w320/au.png",
    CAD: "https://flagcdn.com/w320/ca.png",
    CHF: "https://flagcdn.com/w320/ch.png",
  };

  const imageUrl =
    (option?.symbol && flagUrls[option?.symbol]) ||
    (mediaLink
      ? `https://www.cryptocompare.com/${mediaLink}`
      : "https://via.placeholder.com/24");

  return (
    <div
      className={`dropDownComponent__menu__currencies-item  flex gap-3 items-center  rounded-[0.625rem] w-[95%] px-1 mb-1 cursor-pointer`}
      onClick={() => handleClickOption(option)}
    >
      <img
        className="w-[30px] h-[30px] object-cover rounded-full max-w-[50px]"
        src={imageUrl}
        alt="Crypto"
      />
      <div className={`symbol ${isBitramp() ? "!text-[#fff]":""}`}>{option.code}</div>
    </div>
  );
};

export default CurrencyOption;
